import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus } from "lucide-react";
import GoogleSignInButton from "../UI/GoogleSignInButton/GoogleSignInButton.tsx";
import styles from "./WorkBagHeader.module.scss";

interface WorkBagHeaderProps {
  onInscribirme: (email?: string) => void;
  loginWithGoogleJobBoard?: (credentials: unknown, navigate: ReturnType<typeof useNavigate>, options?: { registrationEntry?: string }) => unknown;
}

const WorkBagHeader: React.FC<WorkBagHeaderProps> = ({
  onInscribirme,
  loginWithGoogleJobBoard,
}) => {
  const [email, setEmail] = useState("");
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onInscribirme(email.trim() || undefined);
  };

  const handleGoogleToken = useCallback(
    (accessToken: string) => {
      if (!loginWithGoogleJobBoard) return;
      setIsGoogleLoading(true);
      Promise.resolve(
        loginWithGoogleJobBoard(accessToken, navigate, { registrationEntry: "header" }) as PromiseLike<unknown>
      ).finally(() => setIsGoogleLoading(false));
    },
    [loginWithGoogleJobBoard, navigate]
  );

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <p className={styles.kicker}>Bolsa de trabajo</p>
        <h1 className={styles.title}>
        Encontrá ofertas en construcción y registrate para postular
        </h1>
        <div className={styles.heroSignup}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formMainRow}>
              <input
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={styles.emailInput}
                aria-label="Email para registrarse"
              />
              <button type="submit" className={styles.inscribirmeButton}>
                <UserPlus size={20} />
                Inscribirme
              </button>
            </div>
            {loginWithGoogleJobBoard ? (
              <GoogleSignInButton
                onAccessToken={handleGoogleToken}
                disabled={isGoogleLoading}
                analyticsSource="work_bag_header"
                layout="embedded"
              />
            ) : null}
          </form>
        </div>
      </div>
    </header>
  );
};

export default WorkBagHeader;
